const roundTime = (value) => Math.round(Math.abs(value));

export default roundTime;
